import user from "@/components/information/user";
import device from "@/components/information/device";
import person from "@/components/information/person";
import car from "@/components/information/car";
import otherDevice from "@/components/information/otherDevice";
import driver from "@/components/information/driver";
import iotCard from "@/components/information/iotCard";
import carType from "@/components/system/carType";
import group from "@/components/information/group";
import role from "@/components/system/role";
var data = [
  {
    path: "/user",
    component: user
  },
  {
    path: "/carType",
    component: carType
  },
  {
    path: "/iotCard",
    component: iotCard
  },
  {
    path: "/device",
    component: device
  },
  {
    path: "/deviceExtend",
    component: otherDevice
  },
  {
    path: "/person",
    component: person
  },
  {
    path: "/car",
    component: car
  },
  {
    path: "/driver",
    component: driver
  },
  {
    path: "/role",
    component: role
  },
  {
    path: "/group",
    component: group
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/base.js